import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    leads: {
      name: "Prospect |||| Prospects",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        name: "Nom",
        company_name: "Entreprise",
        email: "E-mail",
        phone: "Téléphone",
        title: "Titre",
        source: "Source",
        source_helper: "D'où vient ce prospect (import, site web, recommandation...)",
        notes: "Notes",
        status: "Statut",
        assignee_id: "Assigné à",
        disqualify_reason: "Raison",
        last_contact_attempt_at: "Dernière tentative",
      },
      status: {
        new: "Nouveau",
        contacted: "Contacté",
        qualified: "Qualifié",
        disqualified: "Disqualifié",
      },
      action: {
        create: "Ajouter un prospect",
        mark_contacted: "Marquer comme contacté",
        qualify: "Qualifier",
        disqualify: "Disqualifier",
        move_to_leads: "Déplacer vers les prospects",
        call: "Appeler",
        whatsapp: "WhatsApp",
        email: "E-mail",
      },
      converted_to: "Converti en :",
      qualified: "Prospect qualifié et converti.",
      moved_to_leads: "Déplacé vers les prospects.",
      empty: {
        title: "Aucun prospect trouvé",
        description: "Les données brutes/non qualifiées atterrissent ici avant d'être converties en vrai contact.",
      },
      activity: {
        title: "Tentatives de contact",
        empty: "Aucune tentative de contact enregistrée.",
        how_did_it_go: "Comment ça s'est passé ?",
        skip: "Ignorer",
        never: "Jamais contacté",
        you: "Vous",
        count: "%{smart_count} tentative |||| %{smart_count} tentatives",
        channel: {
          call: "Appel",
          whatsapp: "WhatsApp",
          email: "E-mail",
        },
        outcome: {
          no_answer: "Pas de réponse",
          responded: "A répondu",
          wrong_number: "Mauvais numéro",
          not_interested: "Pas intéressé",
          callback_later: "Rappeler plus tard",
        },
      },
    },
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
      filters: {
        only_mine: "Seulement les entreprises que je gère",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
        button: "Importer un fichier CSV",
        complete:
          "Import des contacts terminé. %{importCount} contacts importés, %{errorCount} erreurs",
        progress:
          "%{importCount} / %{rowCount} contacts importés, avec %{errorCount} erreurs.",
        error:
          "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
        imported: "Importé",
        remaining_time: "Temps restant estimé :",
        running: "L'import est en cours, merci de ne pas fermer cet onglet.",
        sample_download: "Télécharger un exemple CSV",
        sample_hint:
          "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
        stop: "Arrêter l'importation",
        csv_file: "Fichier CSV",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        noop: "Les contacts sélectionnés ont déjà cette étiquette",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    deals: {
      name: "Affaire |||| Affaires",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Catégorie",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
      },
      filters: {
        show_not_interested: "Afficher Non intéressé",
      },
      field_categories: {
        misc: "Divers",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      invalid_date: "Date invalide",
    },
    projects: {
      name: "Projet |||| Projets",
      fields: {
        name: "Nom",
        description: "Description",
        sales_id: "Propriétaire",
        member_ids: "Membres",
        nb_issues: "Nombre de tickets",
        created_at: "Créé le",
      },
      action: {
        create: "Créer un projet",
        edit: "Modifier le projet",
        new: "Nouveau projet",
        show: "Voir le projet",
      },
      empty: {
        title: "Aucun projet trouvé",
        description: "Votre liste de projets semble vide.",
      },
    },
    issues: {
      name: "Ticket |||| Tickets",
      fields: {
        title: "Titre",
        description: "Description",
        status: "Statut",
        priority: "Priorité",
        assignee_id: "Assigné à",
        start_date: "Date de début",
        due_date: "Échéance",
        project_id: "Projet",
        sprint_id: "Sprint",
        milestone_id: "Jalon",
      },
      timeline: {
        empty:
          "Aucune tâche avec une échéance pour l'instant — la chronologie a besoin d'au moins une pour tracer un axe.",
      },
      subtasks: {
        title: "Sous-tâches",
        progress: "%{done}/%{total} terminé",
        add_placeholder: "Ajouter une sous-tâche…",
        back_to_parent: "↑ Fait partie d'une tâche plus large",
      },
      action: {
        back_to_issue: "Retour au ticket",
        create: "Créer un ticket",
        new: "Nouveau ticket",
      },
      updated: "Ticket mis à jour",
      empty: {
        title: "Aucun ticket trouvé",
        description: "Ce projet n'a pas encore de tickets.",
      },
    },
    sprints: {
      name: "Sprint |||| Sprints",
      empty: "Aucun sprint pour ce projet pour l'instant.",
      show_all: "Afficher tous les tickets",
      progress: "%{done}/%{total} terminé",
      status: {
        planned: "Planifié",
        active: "Actif",
        completed: "Terminé",
      },
      action: {
        new: "Nouveau sprint",
      },
      burndown: {
        title: "Burndown",
        ideal: "Idéal",
        actual: "Réel",
        needs_dates:
          "Définissez une date de début et de fin pour ce sprint afin de voir un graphique burndown.",
      },
    },
    milestones: {
      name: "Jalon |||| Jalons",
      empty: "Aucun jalon pour ce projet pour l'instant.",
      show_all: "Afficher tous les tickets",
      progress: "%{done}/%{total} terminé",
      due: "Échéance",
      overdue: "En retard",
      action: {
        new: "Nouveau jalon",
      },
    },
    issue_notes: {
      fields: {
        text: "Commentaire",
        date: "Date",
        attachments: "Pièces jointes",
      },
      action: {
        add_this: "Ajouter ce commentaire",
      },
      added: "Commentaire ajouté",
      deleted: "Commentaire supprimé",
      empty: "Aucun commentaire",
      you_added: "Vous avez ajouté un commentaire",
      author_added: "%{name} a ajouté un commentaire",
      inputs: {
        add_note: "Ajouter un commentaire",
      },
      validation: {
        note_or_attachment_required:
          "Un commentaire ou une pièce jointe est requis",
      },
    },
    employees: {
      name: "Employé |||| Employés",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "Email",
        phone: "Téléphone",
        employee_code: "Code employé",
        department: "Département",
        designation: "Poste",
        employment_type: "Type d'emploi",
        status: "Statut",
        date_of_joining: "Date d'embauche",
        date_of_leaving: "Date de départ",
        sales_id: "Compte CRM",
        designation_helper: "Choisissez un département pour affiner cette liste",
        date_of_birth: "Date de naissance",
        address: "Adresse",
        emergency_contact_name: "Nom du contact d'urgence",
        emergency_contact_phone: "Téléphone du contact d'urgence",
        bank_name: "Nom de la banque",
        bank_account_name: "Titulaire du compte",
        bank_account_number: "Numéro de compte",
        bank_ifsc: "Code IFSC / guichet",
        previous_employer: "Employeur précédent",
        previous_designation: "Poste précédent",
        total_experience_years: "Années d'expérience",
        qualification: "Diplôme",
        background: "Parcours",
      },
      sections: {
        basic: "Informations de base",
        employment: "Emploi",
        personal: "Informations personnelles",
        past_employment: "Expérience précédente",
        bank: "Coordonnées bancaires",
        background: "Parcours",
      },
      action: {
        create: "Créer un employé",
        edit: "Modifier l'employé",
        new: "Nouvel employé",
        show: "Afficher l'employé",
      },
      empty: {
        title: "Aucun employé trouvé",
        description: "Il semble que votre liste d'employés soit vide.",
      },
    },
    leave_requests: {
      name: "Demande de congé |||| Demandes de congé",
      fields: {
        employee_id: "Employé",
        leave_type: "Type de congé",
        from_date: "Du",
        to_date: "Au",
        days: "Jours",
        reason: "Motif",
        status: "Statut",
        approved_by: "Approuvé par",
        approved_at: "Approuvé le",
      },
      action: {
        new: "Nouvelle demande de congé",
        approve: "Approuver",
        reject: "Refuser",
        cancel: "Annuler la demande",
        back: "Retour",
      },
      updated: "Demande de congé mise à jour",
      decided: "Demande de congé mise à jour",
      cancelled: "Demande de congé annulée",
      empty: {
        title: "Aucune demande de congé trouvée",
        description: "Il semble que votre liste de demandes de congé soit vide.",
      },
    },
    attendance_records: {
      name: "Présence |||| Présences",
      fields: {
        employee_id: "Employé",
        date: "Date",
        status: "Statut",
        check_in: "Arrivée",
        check_out: "Départ",
        notes: "Notes",
      },
      action: {
        new: "Enregistrer la présence",
        create: "Enregistrer la présence",
      },
      empty: {
        title: "Aucune présence trouvée",
        description: "Il semble que votre registre de présence soit vide.",
      },
    },
    salary_structures: {
      name: "Salaire |||| Salaires",
      fields: {
        employee_id: "Employé",
        basic: "Base",
        allowances: "Primes",
        deductions: "Retenues",
        effective_from: "Effectif à partir du",
      },
    },
    payslips: {
      name: "Bulletin de paie |||| Bulletins de paie",
      fields: {
        employee_id: "Employé",
        month: "Mois",
        year: "Année",
        basic: "Base",
        allowances: "Primes",
        deductions: "Retenues",
        gross_pay: "Salaire brut",
        net_pay: "Salaire net",
        status: "Statut",
      },
      action: {
        new: "Nouveau bulletin de paie",
        create: "Créer le bulletin de paie",
        finalize: "Finaliser",
      },
      finalized: "Bulletin de paie finalisé",
      empty: {
        title: "Aucun bulletin de paie trouvé",
        description: "Il semble que votre liste de bulletins de paie soit vide.",
      },
    },
    transactions: {
      name: "Transaction |||| Transactions",
      fields: {
        date: "Date",
        description: "Description",
        amount: "Montant",
        category: "Catégorie",
        balance_after: "Solde après",
        source: "Source",
        statement_import_id: "Relevé",
        notes: "Notes",
        scope: "Personnel/Professionnel",
        recurring_expense_id: "Dépense récurrente",
      },
      action: {
        new: "Ajouter une transaction",
        create: "Ajouter une transaction",
      },
      empty: {
        title: "Aucune transaction trouvée",
        description: "Il semble que votre liste de transactions soit vide.",
      },
      upload: {
        button: "Importer un relevé",
        title: "Importer un relevé bancaire",
        help: "Importez un relevé bancaire PDF. Rien n'est enregistré tant que vous n'avez pas vérifié et confirmé ci-dessous.",
        default_scope: "Ce relevé concerne :",
        mark_all_as: "Tout marquer comme :",
        parsing: "Lecture du relevé…",
        no_transactions: "Aucune transaction n'a pu être trouvée dans ce PDF. Il utilise peut-être une mise en page différente de celle attendue.",
        parse_error: "Impossible de lire ce PDF. Il ne correspond peut-être pas à la mise en page attendue.",
        wrong_password: "Ce mot de passe n'a pas fonctionné — réessayez.",
        password_placeholder: "Mot de passe du PDF",
        unlock: "Déverrouiller",
        summary: "%{total} transactions trouvées. %{duplicates} ressemblent à des doublons et sont décochées par défaut.",
        mismatch_note: "%{count} présentent un écart de solde — à vérifier avant l'import.",
        possible_duplicate: "Doublon possible",
        balance_mismatch: "Écart de solde",
        import_button: "Importer %{count} transactions",
        success: "%{count} transactions importées.",
        partial_failure: "Importé, mais %{count} ligne(s) ont échoué.",
      },
    },
    statement_imports: {
      name: "Import de relevé |||| Imports de relevés",
      fields: {
        filename: "Nom du fichier",
        period_from: "Période du",
        period_to: "Période au",
        transaction_count: "Transactions",
      },
    },
    recurring_expenses: {
      name: "Dépense récurrente |||| Dépenses récurrentes",
      fields: {
        name: "Nom",
        amount: "Montant",
        category: "Catégorie",
        scope: "Personnel/Professionnel",
        due_day: "Jour d'échéance",
        match_keyword: "Mot-clé de correspondance",
        active: "Active",
      },
      action: {
        create: "Ajouter une dépense récurrente",
      },
      status: {
        active: "Active",
        inactive: "Inactive",
      },
    },
    people: {
      name: "Personne |||| Personnes",
      fields: {
        name: "Nom",
        phone: "Téléphone",
      },
      autocomplete: {
        create_item: 'Ajouter "%{item}"',
        create_label: "Ajouter une nouvelle personne",
        create_error: "Une erreur est survenue lors de l'ajout de cette personne",
      },
    },
    loans: {
      name: "Prêt |||| Prêts",
      fields: {
        person_id: "Personne",
        direction: "Sens",
        amount: "Montant",
        scope: "Personnel/Professionnel",
        notes: "Notes",
      },
      action: {
        add: "Ajouter une entrée",
      },
      also_log_transaction: "Enregistrer aussi dans Comptes (décochez pour un prêt en espèces qui ne passe pas par la banque)",
      transaction_link_error: "Prêt enregistré, mais impossible de l'enregistrer aussi comme transaction — ajoutez-la manuellement si besoin.",
    },
    personal_notes: {
      name: "Note |||| Notes",
      fields: {
        title: "Titre",
        content: "Contenu",
        color: "Couleur",
        tags: "Étiquettes",
        attachments: "Pièces jointes",
        updated_at: "Mis à jour",
        remind_at: "Me le rappeler",
      },
      type: {
        note: "Note",
        checklist: "Liste de contrôle",
      },
      title_placeholder: "Titre",
      content_placeholder:
        "Prenez une note… (markdown pris en charge : - listes, **gras**, etc.)",
      no_color: "Aucune couleur",
      edited: "Modifié",
      action: {
        new: "Nouvelle note",
        pin: "Épingler",
        unpin: "Désépingler",
        archive: "Archiver",
        unarchive: "Désarchiver",
        trash: "Mettre à la corbeille",
        restore: "Restaurer",
        history: "Historique des versions",
        share: "Partager",
        add_person: "Ajouter une personne",
        clear_reminder: "Effacer le rappel",
      },
      tabs: {
        notes: "Notes",
        archived: "Archivées",
        trash: "Corbeille",
      },
      pinned: "Épinglées",
      others: "Autres",
      reminders_due: "Rappels",
      no_versions: "Aucune version antérieure pour le moment.",
      version_restored: "Version restaurée",
      no_one_to_share: "Personne d'autre avec qui partager",
      shared_read_only: "Partagée avec vous — lecture seule.",
      empty: {
        title: "Aucune note trouvée",
        description: "Il semble que votre liste de notes soit vide.",
      },
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        administrator: "Admin",
        disabled: "Désactivé",
        is_developer: "Développeur",
        notes_only: "Notes uniquement",
        is_accounts: "Comptabilité",
        password_helper:
          "Partagez-le directement avec eux — les e-mails d'invitation ne sont pas fiables sur ce projet.",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success: "Utilisateur créé. Partagez son mot de passe directement.",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Quixsyn CRM",
    },
    common: {
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    changelog: {
      title: "Notes de version",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      stepper: {
        install: "Installer Quixsyn CRM",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    header: {
      import_data: "Importer des données",
    },
    hr: {
      my_hr: "Mon espace RH",
      leave_balance: "Solde de congés",
      no_employee_record:
        "Demandez à votre administrateur RH de lier votre compte à une fiche employé.",
      dashboard: {
        nav_label: "Aperçu",
        title: "Aperçu RH",
        headcount: "Effectif",
        pending_leave: "Congés en attente",
        present_today: "Présents aujourd'hui",
        draft_payslips: "Fiches de paie provisoires",
        pending_leave_requests: "Demandes de congé en attente",
        attendance_today: "Présence du jour",
        no_attendance_today: "Aucune présence enregistrée pour l'instant aujourd'hui.",
        headcount_by_department: "Effectif par service",
        no_department: "Non attribué",
        view_employees: "Voir tous les employés",
        no_data: "Ajoutez un employé pour voir un aperçu ici.",
      },
    },
    pm: {
      dashboard: {
        nav_label: "Aperçu",
        title: "Aperçu des projets",
        total_projects: "Projets",
        total_issues: "Total des tâches",
        open_issues: "Tâches ouvertes",
        overdue_issues: "En retard",
        by_status: "Tâches par statut",
        by_priority: "Tâches par priorité",
        no_priority_data: "Aucune donnée pour l'instant.",
        workload: "Tâches ouvertes par assigné",
        no_open_issues: "Aucune tâche ouverte.",
        unassigned: "Non attribué",
        recent_activity: "Tâches récentes",
        view_projects: "Voir tous les projets",
        no_data: "Créez un projet pour voir un aperçu ici.",
      },
      calendar: {
        nav_label: "Calendrier",
        title: "Calendrier des échéances",
        today: "Aujourd'hui",
        more: "de plus",
      },
    },
    accounts: {
      nav_label: "Comptes",
      dashboard: {
        nav_label: "Aperçu",
        title: "Aperçu des comptes",
        total_income: "Revenu total",
        total_expense: "Dépense totale",
        net_savings: "Épargne nette",
        uncategorized: "Non catégorisé",
        uncategorized_hint:
          "%{count} transaction |||| %{count} transactions",
        monthly_trend: "Revenus vs dépenses mensuels",
        top_categories: "Principales catégories de dépenses",
        income_sources: "Sources de revenus",
        balance_trend: "Solde du compte dans le temps",
        recent_transactions: "Transactions récentes",
        transaction_count: "Transactions",
        avg_transaction: "Transaction moyenne",
        no_data: "Importez un relevé pour voir vos finances ici.",
        view_transactions: "Voir toutes les transactions",
        other_category: "Autre",
        click_for_detail: "Cliquez pour voir le détail semaine par semaine",
        back_to_overview: "Vue d'ensemble",
        weekly_trend: "Revenus et dépenses par semaine",
        month_transactions: "%{count} transaction |||| %{count} transactions",
        no_expenses_this_month: "Aucune dépense ce mois-ci.",
        set_budget: "Définir un budget",
        invalid_budget_amount: "Saisissez un montant supérieur à 0.",
        no_data_for_scope: "Aucune transaction dans cette catégorie personnel/professionnel pour le moment.",
        scope_all: "Tout",
        recurring_this_month: "Dépenses récurrentes de ce mois-ci",
        recurring_posted: "Enregistrée",
        recurring_overdue: "En retard",
        recurring_due_day: "Échéance le %{day}",
      },
      khatabook: {
        nav_label: "Khatabook",
        title: "Khatabook",
        no_data: "Rien d'enregistré pour l'instant — ajoutez votre première entrée ci-dessus.",
        owed_to_me: "On me doit",
        i_owe: "Je dois",
        settled: "Réglé",
        owes_you: "Vous doit %{amount}",
        you_owe: "Vous devez %{amount}",
        gave: "Donné",
        received: "Reçu",
        mark_settled: "Marquer comme réglé",
      },
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer des données",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      hr: {
        departments: "Départements",
        designations: "Postes",
        employment_types: "Types d'emploi",
        employee_statuses: "Statuts des employés",
        leave_types: "Types de congé",
        attendance_statuses: "Statuts de présence",
      },
      accounts: {
        categories: "Catégories",
        rules: "Règles de catégorisation",
        rules_help:
          "Lors de l'import d'un relevé, une transaction dont la description contient ce mot-clé est catégorisée automatiquement. Modifiez ces règles pour correspondre à vos relevés réels.",
      },
      notes: {
        statuses: "Statuts",
      },
      projects: {
        statuses: "Statuts des tickets",
        priorities: "Priorités des tickets",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
        hr: "RH",
        accounts: "Comptes",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
          statuses: "statuts",
          priorities: "priorités",
          departments: "départements",
          designations: "postes",
          employment_types: "types d'emploi",
          employee_statuses: "statuts des employés",
          leave_types: "types de congé",
          attendance_statuses: "statuts de présence",
          transaction_categories: "catégories de transaction",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    preferences: {
      title: "Préférences",
      subtitle: "Personnalisez les préférences de mise en page.",
      theme_preset: "Thème",
      fonts: "Polices",
      page_layout: "Mise en page",
      centered: "Centrée",
      full_width: "Pleine largeur",
      navbar_behavior: "Comportement de la barre",
      sticky: "Fixe",
      scroll: "Défilante",
      sidebar_style: "Style de la barre latérale",
      inset: "Encastrée",
      sidebar: "Barre latérale",
      floating: "Flottante",
      sidebar_collapse_mode: "Mode de réduction",
      icon: "Icône",
      offcanvas: "Hors écran",
      note_corners: "Coins des notes",
      rounded: "Arrondis",
      square: "Carrés",
      restore_defaults: "Réinitialiser",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
      groups: {
        overview: "Aperçu",
        crm: "CRM",
        projects: "Projets",
        hr: "RH",
        accounts: "Comptes",
        workspace: "Espace de travail",
      },
    },
    profile: {
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Quixsyn CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
